import { useEffect, useRef, useSyncExternalStore } from "react";

const KEY = "ksp_resort_pick";
const subs = new Set();
let uid = null;
let version = 0;

const readAll = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const mine = () => (uid ? readAll()[uid] || {} : {});
const write = (v) => { const all = readAll(); all[uid] = { ...mine(), ...v }; localStorage.setItem(KEY, JSON.stringify(all)); };
const offIds = () => { const m = mine(); return m.sel ? (m.all || []).filter((x) => x !== m.sel) : []; };
const sync = () => { window.__resortOff = uid ? offIds().join(",") : undefined; };
const notify = () => { sync(); version += 1; subs.forEach((s) => s()); };

export const initResortFilter = (userId) => { if (uid !== userId) { uid = userId; notify(); } };
export const selectedResort = () => mine().sel || null;
// no resort picked = all resorts shown
export const isResortOn = (id) => { const s = mine().sel; return !s || s === id; };
export const setResortIds = (ids) => {
  const m = mine();
  if (JSON.stringify(m.all || []) === JSON.stringify(ids)) return;
  write({ all: ids, sel: ids.includes(m.sel) ? m.sel : null });
  notify();
};
export const toggleResort = (id) => { write({ sel: mine().sel === id ? null : id }); notify(); };

const subscribe = (cb) => { subs.add(cb); return () => subs.delete(cb); };
export const useResortVersion = () => useSyncExternalStore(subscribe, () => version);

// realtime: refresh every 5s while visible, on focus, and when the active resort changes
export const usePoll = (fn, ms = 5000) => {
  const ref = useRef(fn);
  ref.current = fn;
  const v = useResortVersion();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    ref.current();
  }, [v]);
  useEffect(() => {
    const id = setInterval(() => { if (!document.hidden) ref.current(true); }, ms);
    const onShow = () => { if (!document.hidden) ref.current(true); };
    document.addEventListener("visibilitychange", onShow);
    window.addEventListener("focus", onShow);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onShow); window.removeEventListener("focus", onShow); };
  }, [ms]);
};
